import styled, { css } from 'styled-components';
import { space } from 'styled-system';
export const ButtonBase = styled.button.attrs({
    className: 'button',
}) `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;

  height: 40px;
  padding: 8px 24px;
  border-radius: 2px;
  border: none;
  box-sizing: border-box;

  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  cursor: pointer;
  transition-property: border, background-color, color;
  transition-duration: 0.2s;
  -webkit-font-smoothing: antialiased;

  &:focus {
    outline: var(--outline);
    outline-offset: 4px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
    outline-offset: none;
  }

  &:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }

  &::-moz-focus-inner {
    border: 0;
  }

  &::after {
    content: '';

    position: absolute;

    top: -4px;
    bottom: -4px;
    left: 0;
    right: 0;
  }

  & > i {
    text-align: left;
    white-space: nowrap;
  }

  & > .icon-left {
    margin-right: 8px;
  }

  & > .icon-right {
    margin-left: 8px;
  }

  ${space}
`;
export const Contained = styled(ButtonBase).attrs({
    className: 'button',
}) `
  background: var(--color-primary);
  color: var(--color-on-primary);

  &:hover,
  &:focus {
    color: var(--color-on-primary);
    background: var(--color-primary-variant);
  }

  &:active {
    background: var(--color-primary-pressed);
  }

  &[aria-disabled='true'] {
    background: var(--color-disabled-variant);
    color: var(--color-disabled);
    cursor: not-allowed;
  }
`;
export const Outlined = styled(ButtonBase) `
  color: var(--color-primary);
  background: rgba(0, 0, 0, 0);
  border: 1px solid var(--color-primary);

  padding: 7px 23px;

  &:hover,
  &:focus {
    background: var(--color-overlay-hover-darken);
  }

  &:active {
    color: var(--color-primary-pressed);
    border: 1px solid var(--color-primary-pressed);
  }

  &[aria-disabled='true'] {
    border: 1px solid var(--color-disabled-variant);

    background: rgba(0, 0, 0, 0);
    color: var(--color-disabled);
    cursor: not-allowed;
  }

  &::after {
    content: '';

    position: absolute;

    top: -5px;
    bottom: -5px;
    left: 0;
    right: 0;
  }
`;
export const Text = styled(ButtonBase) `
  color: var(--color-primary);
  background: rgba(0, 0, 0, 0);

  &:hover,
  &:active,
  &:focus {
    background: var(--color-overlay-hover-darken);
    color: var(--color-primary-variant);
  }

  &[aria-disabled='true'] {
    background: rgba(0, 0, 0, 0);
    color: var(--color-disabled);
    cursor: not-allowed;
  }
`;
export const Icon = styled.button.attrs({
    className: 'button',
}) `
  position: relative;
  display: inline-flex;

  padding: 0;

  font-size: 16px;
  line-height: 16px;
  color: var(--color-primary);

  border: none;
  /* border-radius: 50%; */
  background-color: transparent;

  transition-property: color;
  transition-duration: 0.2s;

  text-decoration: none;

  cursor: pointer;

  &:hover > i {
    box-shadow:
      inset 0 0 0 8px var(--color-overlay-hover-darken),
      0 0 0 8px var(--color-overlay-hover-darken);
  }

  &:focus {
    outline: var(--outline);
    outline-offset: 16px;
  }
  &:focus:not(:focus-visible) {
    outline: 0;
  }
  &:focus-visible {
    outline: var(--outline);
    outline-offset: 16px;
  }

  & > i {
    margin: 0;
    border-radius: 50%;
    white-space: nowrap;
    transition-property: box-shadow;
    transition-duration: 0.2s;
  }

  ${({ size = 16 }) => size &&
    css `
      & > i {
        font-size: ${size}px;
        line-height: ${size}px;
      }
    `};

  &::after {
    content: '';

    position: absolute;

    top: -16px;
    bottom: -16px;
    left: -16px;
    right: -16px;
  }

  &[aria-disabled='true'] {
    color: var(--color-disabled);

    &:hover > i {
      box-shadow: none;
    }

    cursor: not-allowed;
  }

  ${({ color: colorProp }) => colorProp &&
    css `
      & > i {
        color: var(--color-${colorProp}) !important;
      }
    `}

  ${space}
`;
